<template>
  <v-app-bar
    dense
    flat
  >
    <v-spacer/>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab x-small color="green" class="ml-2 mr-2 white--text"
          @click="onAddClaim"
          :disabled="!addActive"
          v-bind="attrs"
          v-on="on">
          <v-icon dark>mdi-email-plus-outline</v-icon>
        </v-btn>
      </template>
      <span> Новый запрос </span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab x-small color="blue" class="ml-2 mr-2 white--text"
          @click="onSendClaim"
          :disabled="!nextStateActive"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark >mdi-flag-variant</v-icon>
        </v-btn>
      </template>
      <span> Изменить статус </span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab x-small color="red" class="ml-2 mr-2 white--text"
          @click="onDelClaim"
          :disabled="!delActive" v-bind="attrs"
          v-on="on"
        >
          <v-icon dark >mdi-email-off-outline</v-icon>
        </v-btn>
    </template>
    <span> Удалить запрос </span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
export default {
  name: 'claimActionsPanel',
  props: ['claim', 'filter'],
  computed: {
    addActive: {
      get: function () {
        return this.filter.DT_ID !== '-5'
      }
    },
    nextStateActive: {
      get: function () {
        return (typeof this.claim.DOC_ID !== 'undefined') &&
               ((this.claim.COMMENTS_TAB.length) || (this.claim.FILE_LIST.length)) &&
               this.claim.AVAIL_STATUS.length
      }
    },
    delActive: {
      get: function () {
        return (typeof this.claim.DOC_ID !== 'undefined') &&
               (this.claim.DS_ID === '0') &&
               (this.claim.AVAIL_STATUS.filter(itm => itm.SIGNAL_ID === '-3').length) &&
               this.claim.IS_OWN
      }
    }
  },
  methods: {
    onAddClaim () {
      console.log('onAddClaim clicked')
      this.$emit('onCommand', 'addClaim')
    },
    onSendClaim () {
      console.log('onSendClaim clicked')
      this.$emit('onCommand', 'changeStatus')
    },
    onDelClaim () {
      console.log('onDelClaim clicked')
      this.$emit('onCommand', 'deleteClaim')
    }
  }
}
</script>

<style scoped>

</style>
